import React from "react";
import PropTypes from "prop-types";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faComments, faTimes, faAngleDoubleRight, faAngleDoubleLeft, faSync } from "@fortawesome/free-solid-svg-icons";
import "./ChatBotApp.css";
import ChatBarContainer from "../ChatBarContainer";
import { CHAT_VARIANT } from "../constants";
library.add(faComments, faTimes, faAngleDoubleRight, faAngleDoubleLeft, faSync);

const ChatBotApp = ({
  variant = CHAT_VARIANT.DEFAULT
}) => {
  const cssId = "myCss"; // you could encode the css path itself to generate id..

  if (!document.getElementById(cssId)) {
    const head = document.getElementsByTagName("head")[0];
    const link = document.createElement("link");
    link.id = cssId;
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = "/chatbot-mydpd/static/css/main.css";
    link.media = "all";
    head.appendChild(link);
  }

  return /*#__PURE__*/React.createElement("div", {
    id: "chat-view-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    id: "chat-view"
  }, /*#__PURE__*/React.createElement(ChatBarContainer, {
    variant: variant
  })));
};

ChatBotApp.propTypes = {
  variant: PropTypes.oneOf([CHAT_VARIANT.DEFAULT, CHAT_VARIANT.CHAT_BUTTON])
};
export default ChatBotApp;